import { isEmpty, pick } from "lodash";

export const filterObligations = ({
  obligationList = [],
  flag = "main",
  filters = {}
}) => {
  const {
    category = "",
    searchTerm = "",
    filterUsers = "",
    filteredUsers = [],
    action = "",
    assessment = [],
    dueDateFrom = "",
    dueDateTo = ""
  } = filters;
  console.debug({ filters });
  const filteredObligations = obligationList?.filter(obl => {
    let categoryCheck = category ? obl?.mainCategory === category : true;

    let searchTermCheck = searchTerm
      ? (flag === "main" &&
          obl?.law_title?.toUpperCase()?.includes(searchTerm?.toUpperCase())) ||
        obl.description?.toUpperCase()?.includes(searchTerm?.toUpperCase()) ||
        obl?.code?.toUpperCase()?.includes(searchTerm?.toUpperCase())
      : true;

    let ownerCheck = filterUsers
      ? !isEmpty(filteredUsers)
        ? obl?.user_id && filteredUsers?.some(user => user._id === obl.user_id)
        : false
      : true;

    let actionCheck = action ? obl?.action === action : true;

    let assessmentCheck = assessment?.length
      ? assessment?.some(assess => assess === obl?.assessment)
      : true;

    let rangeCheck =
      dueDateFrom || dueDateTo
        ? obl?.dueDate
          ? (dueDateFrom ? obl.dueDate?.slice(0, 10) >= dueDateFrom : true) &&
            (dueDateTo ? obl.dueDate?.slice(0, 10) <= dueDateTo : true)
          : false
        : true;

    return (
      categoryCheck &&
      searchTermCheck &&
      ownerCheck &&
      rangeCheck &&
      actionCheck &&
      assessmentCheck
    );
  });
  return filteredObligations;
};

export const filterAudits = (audits, filters, items) => {
  const {
    searchTerm,
    chosenRange,
    chosenType,
    selectedAssessment,
    selectedUsers,
    selectedIds,
    selectedFramework
  } = filters;
  const { mainObligations, extraObligations, mainDocuments, extraDocuments } =
    items;
  const filterObligations = chosenType?.length ||  selectedAssessment?.length ||  selectedUsers?.length ||  selectedIds?.length ||  selectedFramework?.length;
  let filteredItems = [];
  //filter logic goes here
  //first filter the obligations based on type, ids, assessment, framework, assignee
  if (!chosenType || chosenType === "main") {
    let obligationIds = mainObligations?.filter(o => {
      let assessment = selectedAssessment?.length ? o?.assessment ? selectedAssessment.includes(o?.assessment) : false : true;
      let assignee = selectedUsers?.length ? o?.user_id ? selectedUsers.includes(o?.user_id) : false : true;
      let id = selectedIds?.length ? o?.code ? selectedIds.includes(o?.code) : false : true;
      let framework = selectedFramework?.length ? o?.mainCategory ? selectedFramework.includes(o?.mainCategory) : false : true;
      return assessment && assignee && id && framework;
    })?.map(o => o?._id) ?? [];
    filteredItems = filteredItems.concat(obligationIds);
    if (obligationIds && mainDocuments) {
      //logic to get docs relevant to obligations
      let docIds = []
      for (const ob of obligationIds) {
        docIds = docIds.concat(mainDocuments?.[ob]?.map(d => d?._id) ?? []);
      }
      filteredItems = filteredItems.concat(docIds);
    }
  }
  if (!chosenType || chosenType === "extra") {
    let extraIds = extraObligations?.filter(o => {
      let assessment = selectedAssessment?.length ? o?.assessment ? selectedAssessment.includes(o?.assessment) : false : true;
      let assignee = selectedUsers?.length ? o?.user_id ? selectedUsers.includes(o?.user_id) : false : true;
      let id = selectedIds?.length ? o?.code ? selectedIds.includes(o?.code) : false : true;
      let framework = selectedFramework?.length ? o?.mainCategory ? selectedFramework.includes(o?.mainCategory) : false : true;
      return assessment && assignee && id && framework;
    })?.map(o => o?._id) ?? [];
    filteredItems = filteredItems.concat(extraIds);
    if (extraIds && extraDocuments) {
      //logic to get docs relevant to obligations
      let docIds = []
      for (const ob of extraIds) {
        docIds = docIds.concat(mainDocuments?.[ob]?.map(d => d?._id) ?? []);
      }
      filteredItems = filteredItems.concat(docIds);
    }
  }
  //then get the ids of the filtered obligations
  //get the document metadata ids relevant to the filtered obligation
  //create a list with all these ids
  
  //filter audits with object id included in above ids + in chosenRange + including searchTerm
  const filtered = audits?.filter(audit => {
    let filteredItemCheck = filterObligations ? filteredItems?.length ? filteredItems?.includes(audit?.object_id) : false : true

    let termCheck = searchTerm?.length
      ? audit?.user_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        audit?.action?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        audit?.object_description
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase())
      : true;

    let rangeCheck = chosenRange?.length
      ? (chosenRange[0]
          ? audit.createdAt.slice(0, 10) >= chosenRange[0]
          : true) &&
        (chosenRange[1] ? audit.createdAt.slice(0, 10) <= chosenRange[1] : true)
      : true;

    return filteredItemCheck && termCheck && rangeCheck;
  });

  return filtered;
};
